import styled from 'styled-components'

const ExampleComponent = () => {
  return (
    <PlaceholderText>
      <ShadowText>
        “This is your world. You’re the creator. Find freedom on this canvas.
        Believe, that you can do it, ‘cuz you can do it.”{' '}
      </ShadowText>
      <small>– Bob Ross 🎨</small>
    </PlaceholderText>
  )
}
const ShadowText = styled.p`
  text-shadow: 3px 3px 0 var(--color-2), 6px 6px 0 var(--color-3),
    9px 9px var(--color-4), 12px 12px 0 var(--color-5);
  color: var(--color-1);
  animation: shadows .2s ease-in-out;
  font-weight: 400;
  font-size: calc(1em + 3.5vw);
  line-height: .9;
  margin-bottom: 20px;
  text-transform: uppercase;
  @keyframes shadows {
    from {
      text-shadow: 0px 0px 0 var(--color-secondary),
        0px 0px 0 var(--color-3), 0px 0px var(--color-4),
        0px 0px 0 var(--color-5);
    }
  }
`
const PlaceholderText = styled.div`
  --color-1: #f6b9b0;
  --color-2: #f09f94;
  --color-3: #f29689;
  --color-4: #e97b6d;
  --color-5: #e65d4b;
  height: 100%;
  font-size: 2em;
`

export default ExampleComponent
